// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__3jA90","header":"ReportDetails_header__67_8m","title":"ReportDetails_title__3UTfj","left":"ReportDetails_left__bxdgk"};